export const COMPOUNDS = {
  DIGLYME_DMSO: {
    full_name: 'Diglyme DMSO',
    smiles: 'COCCOCCOC.CS(C)=O',
  },
  DIGLYME_DMSO_WATER: {
    full_name: 'Diglyme DMSO Water',
    smiles: 'COCCOCCOC.CS(C)=O.O',
  },
  PDDPPFCL2: {
    full_name: 'Pd(dppf)cl2',
    smiles: 'C1=CC([Fe]C2(P(c3ccccc3)c3ccccc3)C=CC=C2)(P(c2ccccc2)c2ccccc2)C=C1.Cl[Pd]Cl',
  },
  SODIUM_CARBONATE: {
    full_name: 'Sodium carbonate',
    smiles: 'O=C([O-])[O-].[Na+].[Na+]',
  },
  DMSO_WATER: {
    full_name: 'DMSO Water',
    smiles: 'CS(C)=O.O',
  },
  DMF_DMSO: {
    full_name: 'DMF DMSO',
    smiles: 'CN(C)C=O.CS(C)=O',
  },
  DMAC_WATER: {
    full_name: 'DMAc Water',
    smiles: 'CC(=O)N(C)C.O',
  },
  SPHOS_G3: {
    full_name: 'SPhos Pd G3',
    smiles: 'COc1cccc(OC)c1-c1ccccc1P(C1CCCCC1)C1CCCCC1.CS(=O)(=O)O[Pd]c1ccccc1-c1ccccc1N',
  },
  POTASSIUM_CARBONATE: {
    full_name: 'Potassium carbonate',
    smiles: 'O=C([O-])[O-].[K+].[K+]',
  },
  TEA: {
    full_name: 'Triethylamine',
    smiles: 'CCN(CC)CC',
  },
  TBUOK: {
    full_name: 't-BuOK',
    smiles: 'CC(C)(C)[O-].[K+]',
  },
  NBUOH_DMSO_WATER: {
    full_name: 'n-BuOH DMSO Water',
    smiles: 'CCCCO.CS(C)=O.O',
  },
  XPHOS_G3: {
    full_name: 'XPhos Pd G3',
    smiles:
      'CC(C)c1cc(C(C)C)c(-c2ccccc2P(C2CCCCC2)C2CCCCC2)c(C(C)C)c1.CS(=O)(=O)O[Pd]c1ccccc1-c1ccccc1N',
  },
  POTASSIUM_PHOSPHATE: {
    full_name: 'Potassium phosphate',
    smiles: 'O=P([O-])([O-])[O-].[K+].[K+].[K+]',
  },
  PD_ACETATE: {
    full_name: 'Palladium(II) acetate',
    smiles: 'CC(=O)[O-].CC(=O)[O-].[Pd+2]',
  },
  MORDALPHOS_G3: {
    full_name: 'MorDalphos Pd G3',
    smiles:
      'CS(=O)(=O)O[Pd]c1ccccc1-c1ccccc1N.c1ccc(P([C@]23C[C@H]4C[C@H](C[C@H](C4)C2)C3)[C@]23C[C@H]4C[C@H](C[C@H](C4)C2)C3)c(N2CCOCC2)c1',
  },
  CESIUM_CARBONATE: {
    full_name: 'Cesium carbonate',
    smiles: 'O=C([O-])[O-].[Cs+].[Cs+]',
  },
  ETHYLPHOSPHONIC_CYCLIC_ANHYDRIDE: {
    full_name: '1-Ethylphosphonic cyclic anhydride',
    smiles: 'CCCP1(=O)OP(=O)(CCC)OP(=O)(CCC)O1',
  },
  HUNIGS_BASE: {
    full_name: "Hünig's base",
    smiles: 'CCN(C(C)C)C(C)C',
  },
  EDC: {
    full_name: 'EDC',
    smiles: 'CCN=C=NCCCN(C)C.Cl',
  },
  COMU: {
    full_name: 'COMU',
    smiles: 'CCOC(=O)C(C#N)=NOC(N1CCOCC1)=[N+](C)C.F[P-](F)(F)(F)(F)F',
  },
  TFFH: {
    full_name: 'TFFH',
    smiles: 'CN(C)C(F)=[N+](C)C.F[P-](F)(F)(F)(F)F',
  },
  TSTU: {
    full_name: 'TSTU',
    smiles: 'CN(C)C(ON1C(=O)CCC1=O)=[N+](C)C.F[B-](F)(F)F',
  },
  HATU: {
    full_name: 'HATU',
    smiles: 'CN(C)[C+](N(C)C)n1n[n+]([O-])c2ncccc21.F[P-](F)(F)(F)(F)F',
  },
  DMTMM_BF4: {
    full_name: 'DMTMM-BF4',
    smiles: 'COc1nc(OC)nc([N+]2(C)CCOCC2)n1.F[B-](F)(F)F',
  },
  PYBOP: {
    full_name: 'PyBOP',
    smiles: 'F[P-](F)(F)(F)(F)F.c1ccc2c(c1)nnn2O[P+](N1CCCC1)(N1CCCC1)N1CCCC1',
  },
  CDI: {
    full_name: 'CDI',
    smiles: 'O=C(n1ccnc1)n1ccnc1',
  },
  DBU: {
    full_name: 'DBU',
    smiles: 'C1CCC2=NCCCN2CC1',
  },
  BRETTPHOS_G3: {
    full_name: 'BrettPhos Pd G3',
    smiles:
      'COc1ccc(OC)c(P(C2CCCCC2)C2CCCCC2)c1-c1c(C(C)C)cc(C(C)C)cc1C(C)C.CS(=O)(=O)O[Pd]c1ccccc1-c1ccccc1N',
  },
  ADBRETTPHOS_G3: {
    full_name: 'AdBrettPhos Pd G3',
    smiles:
      'CS(=O)(=O)O[Pd-2]1([P+](c2ccccc2)(c2ccccc2)c2ccc3ccccc3c2-c2c(P(c3ccccc3)c3ccccc3)ccc3ccccc23)[NH2+]c2ccccc2-c2ccccc21',
  },
  TBUBRETTPHOS_G3: {
    full_name: 'tBuBrettPhos Pd G3',
    smiles:
      'COc1ccc(OC)c(P(C(C)(C)C)C(C)(C)C)c1-c1c(C(C)C)cc(C(C)C)cc1C(C)C.CS(=O)(=O)O[Pd]c1ccccc1-c1ccccc1N',
  },
  TBUXPHOS_G3: {
    full_name: 'tBuXPhos Pd G3',
    smiles:
      'CC(C)c1cc(C(C)C)c(-c2ccccc2P(C(C)(C)C)C(C)(C)C)c(C(C)C)c1.CS(=O)(=O)O[Pd]c1ccccc1-c1ccccc1N',
  },
} as const;

export const COMPOUND_NAME_FROM_SMILES = Object.fromEntries(
  Object.entries(COMPOUNDS).map(([key, value]) => [value.smiles, value.full_name])
);
